import {
	NAVIGATE,
	SET_SUBHEADER_TEXT,
	SET_SUBHEADER_ACTIONS,
	SET_CREATABLE_CONTEXT,
} from "./types";

export function navigate(newPath) {
	return function (dispatch) {
		console.log("navigated", newPath);
		dispatch({
			type: NAVIGATE,
			location: newPath,
		});
	};
}
export function setSubheaderText({
	subheaderText,
	subheaderIconName,
	subHeaderHeight = 64,
}) {
	return function (dispatch) {
		dispatch({
			type: SET_SUBHEADER_TEXT,
			payload: {
				subheaderText,
				subheaderChips: [],
				subheaderIconName,
				subHeaderHeight,
			},
		});
	};
}
export function setSubheaderActions(actions) {
	return function (dispatch) {
		dispatch({ type: SET_SUBHEADER_ACTIONS, payload: actions });
	};
}
export function setCreatableContext(creatable) {
	return function (dispatch) {
		dispatch({
			type: SET_CREATABLE_CONTEXT,
			payload: creatable,
		});
	};
}
